var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('tomillo_header'),_c('router-view'),_c('tomillo_footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }